
import * as ipxRuntime$_6LV4BPxR0_455WOcVtBD4JjLodY23W1oWU6V3rttD2r0k from '/home/ubuntu/Lagerverwaltung/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {
    "avatar": {
      "modifiers": {
        "width": 32,
        "height": 32
      }
    }
  },
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$_6LV4BPxR0_455WOcVtBD4JjLodY23W1oWU6V3rttD2r0k, defaults: {"maxAge":3600} }
}
        